<template>
    <div
        v-if="$root.isMobile"
        style="
            position: fixed;
            bottom: 0;
            right: 0;
            left: 0;
            padding: 20px;
            background: #eee;
            border-top: 1px solid #ddd;
            z-index: 100;
        "
    >
        <button
            v-if="singleOption"
            class="btn btn--quaternary btn--full"
            @click="$root.buyTickets.opened = tabToBeOpened"
        >
            {{ buyTicketsText }}
        </button>
        <button
            v-else
            class="btn btn--quaternary btn--full"
            v-scroll-to="scrollToConfig"
        >
            {{ buyTicketsText }}
        </button>
    </div>
</template>
<script>
export default {
    props: {
        tenantId: {
            required: true,
            type: Number,
        },
        schedule: {
            required: true,
            type: Object,
        },
        hasSeated: {
            required: true,
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            tabToBeOpened: "",
        };
    },
    computed: {
        singleOption() {
            let optionsCount = 0;
            if (this.schedule.tickets.length > 0) {
                optionsCount++;
                this.tabToBeOpened = "standing";
            }
            if (this.hasSeated) {
                optionsCount++;
                this.tabToBeOpened = "seating";
            }
            if (this.schedule.bestAvailable.length > 0) {
                optionsCount++;
                this.tabToBeOpened = "best";
            }
            if (optionsCount === 1) {
                return true;
            }
            return false;
        },
        scrollToConfig() {
            let offsetValue = 0;
            if (this.tenantId == 70) {
                offsetValue = -110;
            } else if (this.tenantId == 145) {
                offsetValue = -250;
            }
            return {
                offset: offsetValue,
                el: "#tickets",
            };
        },
        buyTicketsText() {
            if (this.schedule.buy_button_text) {
                return this.schedule.buy_button_text;
            }

            if (this.schedule.event && this.schedule.event.buy_button_text) {
                return this.schedule.event.buy_button_text;
            }

            return this.__("Buy Tickets");
        }
    },
};
</script>



// WEBPACK FOOTER //
// resources/js/components/BuyTicketsButton.vue